<template>
  <div :class="$style.container">
    <div v-show="!isLoading">
      <CurrentOsReleaseTrains :class="$style.sectionSpacer" />
      <UpgradeNudge :class="$style.sectionSpacer" />
      <div
        :class="$style.mainPanelContainer"
        data-test-id="OsPatchManagementMainPanel__container"
      >
        <OsPatchManagementItemTable
          ref="itemTable"
          :class="$style.itemTableContainer"
          :gettingStartedItemType="gettingStartedPanelItemType"
          :itemType="itemType"
          :useDropDownFilterComponent="
            FilterComponentConsts.OsPolicyDropDownFilter
          "
          :viewport="viewport"
          @loaded="onLoaded"
        />
      </div>
    </div>
    <LoadingOverlay
      :showLoadingOverlay="isLoading"
    />
  </div>
</template>

<script>
import { FilterComponentConsts } from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import { timeoutFunction } from 'client/util/timeoutUtils';
import CurrentOsReleaseTrains from 'client/policies/CurrentOsReleaseTrains.vue';
import LoadingOverlay from 'components/LoadingOverlay/LoadingOverlay.vue';
import MainPanelMixin from 'components/MainPanel/mixins/MainPanelMixin';
import MspState from 'client/components/models/MspState';
import OsPatchManagementItemTable from 'client/OsManagement/OsPatchManagementItemTable';
import UpgradeNudge from 'client/components/Nudge/UpgradeNudge.vue';

export default {
  name: 'OsPatchManagementMainPanel',

  components: {
    CurrentOsReleaseTrains,
    LoadingOverlay,
    OsPatchManagementItemTable,
    UpgradeNudge,
  },

  mixins: [MainPanelMixin],

  data: () => ({
    FilterComponentConsts,
    isLoading: true,
  }),

  computed: {
    ...mapGetters('SettingsModule', [
      'hasBilling',
    ]),

    hasBillingRole() {
      return this.hasBilling
        && !MspState.isAnMspOrChild;
    },
  },

  created() {
    this.fetchPlanInfo();
  },

  methods: {
    ...mapActions('PlanModule', ['fetchPlan']),

    async fetchPlanInfo() {
      if (this.hasBillingRole) await this.fetchPlan();
    },

    onLoaded() {
      // The timeout is used here in order to get some delay time for the spinner to dissappear
      // and the LoadingOverlay in the ui-components library is not being used for consistency
      // with the rest of the admin portal.
      timeoutFunction(() => {
        this.isLoading = false;
        // This dispatch is used to fix the Apexchart render issue on OS event graph
        // Once the OSPM itemTable loaded dispatch the event to render the chart
        // https://github.com/apexcharts/vue3-apexcharts/issues/3
        window.dispatchEvent(new Event('resize'));
      }, 300);
    },
  },
};
</script>

<style module>
.container {
  background: var(--jcWhite300);
  position: relative;
}

.itemTableContainer {
  height: calc(100vh - 86px);
}

.sectionSpacer {
  margin: 0 20px;
}
</style>
